import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { getHomeFullPath } from '@app/routes-definitions';
import { UserStoreSelectors, UserStoreState } from '@core-lib/store/user-store';
import { Store, select } from '@ngrx/store';
import { Observable, of } from 'rxjs';
import { filter, first, map } from 'rxjs/operators';

@Injectable({
	providedIn: 'root'
})
export class RouteWithPermissionsGuard  {
	constructor(
		private router: Router,
		private store: Store<UserStoreState.IUserStoreState>
	) {}

	canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
		if (!next?.data?.canAccess) {
			return of(true);
		}
		return this.store.pipe(
			select(UserStoreSelectors.selectUserPermissions),
			filter(p => p?.length > 0),
			map(permissions => {
				const canAccess = !!next.data.canAccess(permissions);

				if (!canAccess) {
					if (next.data.notAllowedUrl) {
						this.router.navigate([next.data.notAllowedUrl]);
					} else {
						this.router.navigate([getHomeFullPath()]);
					}
				}
				return canAccess;
			}),
			first()
		);
	}
}
